import React from 'react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-100 py-16 px-8">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex items-center justify-between">
          {/* Get in Touch */}
          <div>
            <h3 className="text-4xl font-bold text-red-600 lowercase mb-4">
              get in touch
            </h3>
          </div>

          {/* Contact Info */}
          <div className="text-right">
            <p className="text-lg text-black mb-2">
              <span className="font-semibold">email:</span> {companyInfo.email}
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 text-center text-sm text-gray-600">
          <p>© 2025 {companyInfo.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;